import React from 'react'
import PropTypes from 'prop-types'
import { Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useUser } from '@fs/zion-user'
import AgreePrivacyTermsField from './AgreePrivacyTermsField'
import ReceiveMessagesField from './ReceiveMessagesField'

export default function AgreementAndSubscriptionFields({ implicitSubscribe = false }) {
  const user = useUser()
  const [t] = useTranslation()

  return (
    <>
      {!user.signedIn && (
        <Row gutters="xs">
          <AgreePrivacyTermsField />
        </Row>
      )}
      {implicitSubscribe ? (
        <Row>
          <div /> {/** Why is this empty div here? */}
          {t(
            'conference-announce.subscribe.receive-messages',
            'I would like to receive messages from RootsTech by FamilySearch, including news about future events to the email address or mobile number I provided.'
          )}
        </Row>
      ) : (
        <Row>
          <ReceiveMessagesField />
        </Row>
      )}
    </>
  )
}

AgreementAndSubscriptionFields.propTypes = {
  implicitSubscribe: PropTypes.bool,
}
